module.exports = {"id":"dp5_2l3q5","text":"Identifying Needs and Digital Technological Responses","instructions":"How often do you explore new configuration options to better suit user needs?","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"5.2","questionType":"Scale","random":false,"options":[{"id":"dp5_2l3q5-a1","text":"Never","score":2},{"id":"dp5_2l3q5-a2","text":"Rarely","score":2.4},{"id":"dp5_2l3q5-a3","text":"Sometimes","score":3},{"id":"dp5_2l3q5-a4","text":"Often","score":3.6},{"id":"dp5_2l3q5-a5","text":"Very often","score":4}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat5.2/l3q5.json
// module id = 1311
// module chunks = 41